import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const companyPersonRelationDataClassName = DataClassName.COMPANY_PERSON_RELATION
const companyPersonEndpoint = PisaDataClassEndpoint.COMPANY_PERSON

export function pisaCompanyPersonRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(companyPersonRelationDataClassName, {
    title: companyPersonRelationDataClassName,
    restApi: createPisaRestApiConfig(companyPersonEndpoint),
    attributes,
  })
}
